import { computed } from 'mobx';

import FormFieldGroup from '../../../../../shared/stores/models/FieldModels/FormFieldGroupField';
import MultiStepForm from '../../../../../shared/stores/models/MultiStepForm';
import { RequestObjectExtraFieldsDataType } from '../../../../../shared/types/zodSchemaTypes';
import { ProductResponseTypesDTO } from '../../../../stores/dtos/product.dtos';
import {
  ProductErrorMessageConfigType,
  ProductExtraDataType,
  ProductInfoType,
  RegistrationMessagesConfigType
} from '../../../../types/ProductTypes';

import { Product } from '../../Product';
import { ProductSegmentEvent } from '../../ProductSegmentEvent';

abstract class BaseProduct extends Product {
  productCode: string;
  extraData: ProductExtraDataType | undefined;
  isActive: boolean;
  productConfig: ProductSegmentEvent;
  program: string;
  programExtraInfo: string;
  currency: string;
  dependentProductCode: string;
  dependentProductCodeCondition: string;
  allowedNumberOfPurchases: number;
  programInfo: string;
  programConfig: string;
  programImageURL: string;
  programSubscriptionURL: string;
  errorMessagesConfig: ProductErrorMessageConfigType;
  registrationMessagesConfig: RegistrationMessagesConfigType;
  tncToAccept: Array<string>;
  productInfo: ProductInfoType;
  form!: MultiStepForm;
  formType: string;
  requestObjectExtraFieldData: RequestObjectExtraFieldsDataType;

  constructor(productObject: ProductResponseTypesDTO) {
    super();
    this.productCode = productObject.productCode;
    this.program = productObject.program;
    this.currency = productObject.currency;
    this.dependentProductCode = productObject.dependentProductCode;
    this.dependentProductCodeCondition =
      productObject.dependentProductCodeCondition;
    this.extraData = productObject.extraData;
    this.registrationMessagesConfig = productObject.registrationMessagesConfig;
    this.errorMessagesConfig = productObject.errorMessagesConfig;

    this.isActive = productObject.isActive;
    this.productConfig = new ProductSegmentEvent(
      productObject.productSegmentConfig
    );
    this.programExtraInfo = productObject.programExtraInfo;
    this.allowedNumberOfPurchases = productObject.allowedNoOfPurchases;
    this.programInfo = productObject.programInfo;
    this.programConfig = productObject.programConfig;
    this.programImageURL = productObject.programImageUrl;
    this.programSubscriptionURL = productObject.programSubscriptionUrl;
    this.tncToAccept = productObject.tncToAccept;
    this.productInfo = productObject.productInfo;
    this.formType = productObject.formFieldStepConfig.form_type;
    this.requestObjectExtraFieldData =
      productObject.formFieldStepConfig.request_object_extra_fields_data;
  }

  @computed
  get formInitialValues() {
    const formInitialValuesObject: Record<string, string> = {};
    this.form?.allFormFields?.forEach((eachField) => {
      if (eachField instanceof FormFieldGroup) {
        eachField.formFields.forEach((field) => {
          formInitialValuesObject[field.field] = field.initialValue;
        });
      } else formInitialValuesObject[eachField.field] = eachField.initialValue;
    });
    return formInitialValuesObject;
  }
}

export default BaseProduct;
